// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__sXBBb","header":"MessagesList_header__ONGgj","chat":"MessagesList_chat__1JLbA"};